import React from "react";

import ShipeeziNewGrid, { Column } from "Components/AppGrid/shipeezi-new-grid";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { Cronjob } from "Models/cronjob";
import { User } from "Models/user";
import { CronjobHistoryType } from "Util/enums";

interface EditActivitiesSectionProps {
  cronJob: Cronjob;
}

export const EditActivitiesSection = (props: EditActivitiesSectionProps) => {
  const { cronJob } = props;
  const { t: translate } = useTranslation();

  const columns: Column[] = [
    {
      name: "createdAt",
      title: translate("timestamp"),
      formatComponent: (text: string) => (text ? format(new Date(text), "dd/MM/yyyy hh:mm a") : "-"),
    },
    {
      name: "changes",
      title: translate("changes"),
      formatComponent: (value: string) => value,
    },
    {
      name: "user",
      title: translate("modifiedBy"),
      formatComponent: (user: User) => {
        return user?.fullName || user?.name
      },
    },
  ];

  return (
    <ShipeeziNewGrid
      data={cronJob?.histories?.filter((history) => history.action.toLowerCase() !== CronjobHistoryType.SENT) || []}
      columns={columns}
      positionActionsColumn="right"
      showHeaderGrid={false}
      showFooterGrid={false}
      showColumnChooser={false}
      showSelection={false}
      keyExtractor={(data) => data?.id?.toString()}
      emptyData={translate("noInformationToBeShown")}
    />
  );
};
